export const RESET_STATE = "RESET_STATE";

export const resetStateAction ={
    resetState: () => ({ type: RESET_STATE }),
}